import { Component, Injector, OnInit } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService } from '@app/services';
import { FileHelperService } from '@app/services/file-helper.service';
import { NotifyService } from '@app/services/notify.service';
import { Report } from '../../services/queries/report';

@Component({
    templateUrl: './time-to-fill-report.template.html',
    styleUrls: ['./time-to-fill-report.style.scss'],
    providers: [
        {
            provide: Report,
            useFactory: (fileService: FileHelperService): Report => new Report(fileService),
            deps: [FileHelperService],
        },
    ],
})
export class TimeToFillReportView implements OnInit {
    isLoading = false;
    isError = false;
    report!: Report;
    reportLoaded = false;

    constructor(
        private readonly notifyService: NotifyService,
        private readonly analyticsService: AnalyticService,
        private readonly injector: Injector
    ) {}

    async ngOnInit(): Promise<void> {
        await this.fetchReport();
    }

    async fetchReport(): Promise<void> {
        this.isLoading = true;

        try {
            this.report = await this.injector.get(Report).name('timeToFill').page(1).get();
            this.reportLoaded = this.report?.data?.sheets?.length > 0;
        } catch (error) {
            this.notifyService.error(error);
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    onExport(contentType: string): void {
        this.analyticsService.trackEvent(AnalyticEvents.ClickTimeToFillReportExport);

        this.report.export(contentType).catch(() => {
            this.notifyService.error('reporting.reports.errorExportingReport');
        });
    }
}
